.<template>
  <div>
    <div class="row justify-content-center mb-2">
      <button class="btn btn-add" id="v-step-0" @click="startTour">
        Iniciar Tour
      </button>
    </div>
    <div class="row justify-content-center" id="v-step-1"></div>
    <v-tour name="myTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step1, index) of tour.steps"
            :key="index"
            :step="step1"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template>
              <div slot="actions">
                <button
                  v-if="tour.currentStep != 0"
                  @click="tour.previousStep"
                  class="btn-step-back"
                >
                  Anterior
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  class="btn-step-back"
                >
                  Pular tour
                </button>
                <button
                  @click="
                    nextTour(
                      tour.currentStep,
                      tour.steps[index + 1],
                      tour.steps[index]
                    )
                  "
                  v-if="tour.currentStep != 1"
                  class="btn-step"
                >
                  Próximo
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  v-else
                  class="btn-step"
                >
                  Finalizar
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <base-crud
      crudName="Salas de Reunião"
      newText="Nova Sala de Reunião"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="true"
      :dataForm="dataForm"
      @lockRoom="lockRoom"
      @tvUrl="openTvModal"
      :extra="extra"
    />
    <b-modal id="modal-tv-url" title="Link público da TV" hide-footer>
      <p class="text-muted">
        Abra esta URL em uma TV ou tablet para exibir a agenda desta sala.
        Não requer login. Qualquer pessoa com o link poderá visualizar os horários.
      </p>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          :value="tvUrl"
          readonly
          ref="tvUrlInput"
          @focus="$event.target.select()"
        />
      </div>
      <div class="text-right">
        <button class="btn btn-add" @click="copyTvUrl">
          <i class="fa fa-copy"></i>
          {{ tvCopied ? 'Copiado!' : 'Copiar' }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data: function () {
    return {
      tvUrl: "",
      tvCopied: false,
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud check",
          icon: "fas fa-calendar-times",
          title: "Horários de Bloqueio",
          name: "lockRoom",
        },
        {
          id: 2,
          label: "",
          class: "btn btn-crud check",
          icon: "fas fa-tv",
          title: "Link público da TV",
          name: "tvUrl",
        },
      ],

      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Tela de Reservas de Estação de Trabalho!",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content:
            "Na tela principal de Salas de Reunião temos os Filtros de: ID, Título, Tag, Data Início, Empresa, Filial, Andar, Nº da Sala e Qtd de Pessoas. Em ações temos os botões <i class='fas fa-eye'></i> para consultar a Sala de Reunião, <i class='fas fa-pencil-alt'></i> para editar, <i class='fas fa-trash-alt'></i> para deletar e <i class='fas fa-calendar-times'></i> para bloquear a sala de reunião no período informado para não ser utilizada nas reservas. Para iniciar o tour de como criar uma nova Sala de Reunião, clique em Nova Sala de Reunião",
        },
      ],

      table: "rooms",
      columns: [
        "id",
        "photo",
        "qrcodeid",
        "title",
        "tag",
        "company_id",
        "branch_id",
        "floor",
        "number_room",
        "capacity",
        "actions",
      ],
      tableData: [
        "id",
        "photo",
        "qrcodeid",
        "title",
        "tag",
        "company_id",
        "branch_id",
        "floor",
        "number_room",
        "capacity",
      ],
      options: {
        filterable: [
          "id",
          "title",
          "tag",
          "floor",
          "company_id",
          "branch_id",
          "number_room",
          "capacity",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          photo: "Foto",
          qrcodeid: "QRCode",
          title: "Titulo",
          tag: "Tag",
          company_id: "Empresa",
          branch_id: "Filial",
          floor: "Andar",
          number_room: "Nº da Sala",
          capacity: "Qtd de Pessoas",
          actions: "Ações",
        },

        templates: {
          company_id: function (h, row, index) {
            return row.company ? row.company.company_name : "Sem Nome";
          },
          branch_id: function (h, row, index) {
            return row.branch ? row.branch.title : "Sem Nome";
          },
          qrcodeid: function (h, row, index) {
            return "room-" + row.qrcodeid;
          },
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company", "branch"];
          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "rooms/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => {});
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 31) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    query: function (query) {
      let columns = {
        id: "id",
        photo: "photo",
        title: "title",
        tag: "tag",
        company_id: "company[company_name]",
        branch_id: "branch[title]",
        floor: "floor",
        number_room: "number_room",
        capacity: "capacity",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
    lockRoom(row) {
      this.$router.push("/rooms/lock/" + row.row.id);
    },
    openTvModal(row) {
      const self = this;
      const id = row.row.id;
      const api = self.$store.state.api + "rooms/" + id + "/tv-url";

      self.$http
        .get(api)
        .then((response) => {
          self.tvUrl = response.data.url;
          self.tvCopied = false;
          self.$bvModal.show("modal-tv-url");
        })
        .catch(() => {
          self.$message(null, "Não foi possível gerar o link da TV", "error");
        });
    },
    copyTvUrl() {
      const self = this;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(self.tvUrl).then(() => {
          self.tvCopied = true;
          setTimeout(() => { self.tvCopied = false; }, 2000);
        });
      } else if (self.$refs.tvUrlInput) {
        self.$refs.tvUrlInput.select();
        document.execCommand("copy");
        self.tvCopied = true;
        setTimeout(() => { self.tvCopied = false; }, 2000);
      }
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Rooms/Crud.vue